// extracted by mini-css-extract-plugin
export default {"content":"CustomizeNavigation_content__tqALH","tabs":"CustomizeNavigation_tabs__IQ9qX"};